export const handlingUnitMock = {
  id: '99e01877-cd09-4837-8c45-8b89db51bbde',
  name: 'Barrel 100 ltr',
  description: 'Brl100',
  isDefault: false,
  isActive: true,
};
